import getAll from '@/api/ville/index';

export default async function getAllVilles(villeName, tableName) {
  const villesAutocomplete = [];
  if (!villeName.length) {
    return villesAutocomplete;
  }
  return (await getAll({
    query: {
      ville: villeName,
      table: [tableName],
    },
    ascending: true,
  })).data.result.items;
}
